export default "__VITE_PUBLIC_ASSET__e0d699ae__"